import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  isApprover: boolean
  isHqAdmin: boolean
}

export function HqCommandPalette({ isApprover, isHqAdmin }: Props) {
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setOpen((v) => !v)
      }
      if (e.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const items = useMemo(() => {
    const base = [
      { label: 'Home', path: '/simple-hq' },
      { label: 'My leave', path: '/simple-hq/leave/request' },
      { label: 'Leave calendar', path: '/simple-hq/leave/calendar' },
      { label: 'My work', path: '/simple-hq/work' },
      { label: 'Projects', path: '/simple-hq/projects' },
    ]
    if (isApprover) base.push({ label: 'Leave approvals', path: '/simple-hq/leave/approvals' })
    if (isHqAdmin) {
      base.push(
        { label: 'People & leave', path: '/simple-hq/leave/people' },
        { label: 'Leave types', path: '/simple-hq/leave/types' },
        { label: 'Delegates', path: '/simple-hq/settings/delegates' },
      )
    }
    const qq = q.trim().toLowerCase()
    return qq ? base.filter((i) => i.label.toLowerCase().includes(qq)) : base
  }, [q, isApprover, isHqAdmin])

  if (!open) return null

  return (
    <div className="hq-cmdk" role="dialog" aria-label="Command palette" onClick={() => setOpen(false)}>
      <div className="hq-cmdk-panel" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          placeholder="Go to…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        {items.map((item) => (
          <button
            key={item.path}
            type="button"
            onClick={() => {
              navigate(item.path)
              setOpen(false)
              setQ('')
            }}
          >
            {item.label}
          </button>
        ))}
        {items.length === 0 && <p className="hq-empty px-4 py-3">No matches</p>}
      </div>
    </div>
  )
}
